import { AppActions, AppActionTypes } from './actions';
import { AppState } from '../shared/models';

export const initialState = {};

// add switch cased to the reducer for every action
// or combine reducers from the reducers subfolder right here
export const appReducer = (state: AppState = initialState, action: AppActions): AppState => {
  switch (action.type) {
  case AppActionTypes.SetCropFieldAdvices: {
    return {
      ...state,
      cropFieldAdvices: [...action.cropFieldAdvices],
    };
  }

  case AppActionTypes.SetCrops: {
    return {
      ...state,
      crops: [...action.crops],
    };
  }

  case AppActionTypes.SetNonProductiveCrops: {
    return {
      ...state,
      nonProductiveCrops: [...action.nonProductiveCrops],
    };
  }

  case AppActionTypes.SetDefaultCropYear: {
    return {
      ...state,
      defaultCropYear: action.cropYear,
    };
  }

  case AppActionTypes.SetAvailableCropYears: {
    return {
      ...state,
      availableCropYears: action.availableCropYears,
    };
  }

  case AppActionTypes.SetLoggedInEmployeeData: {
    return {
      ...state,
      loggedInEmployee: action.loggedInEmployee,
    };
  }

  case AppActionTypes.SetSkalReport: {
    return {
      ...state,
      skalReport: action.skalReport,
    };
  }

  case AppActionTypes.SetPlanetProofReport: {
    return {
      ...state,
      planetProofReport: action.planetProofReport,
    };
  }

  case AppActionTypes.SetEnvironmentalImpactReport: {
    return {
      ...state,
      environmentalImpactReport: action.environmentalImpactReport,
    };
  }

  case AppActionTypes.SetReportSort: {
    return {
      ...state,
      reportSort: action.reportSort,
    };
  }

  case AppActionTypes.LoadCustomerProgressSuccess: {
    return {
      ...state,
      customerProgress: action.customerProgress,
    };
  }

  case AppActionTypes.SetCompanySettings: {
    return {
      ...state,
      companySettings: action.companySettings,
    };
  }

  case AppActionTypes.SetSoilTypes: {
    return {
      ...state,
      soilTypes: action.soilTypes,
    };
  }

  case AppActionTypes.CropFieldDeleted: {
    return {
      ...state,
      cropFieldAdvices: state.cropFieldAdvices.filter((cfa)=> cfa.cropFieldId !== action.cropFieldId),
    };
  }

  default:
    return state;
  }
};
